import { render, staticRenderFns } from "./TheSecurity.vue?vue&type=template&id=5a922495&scoped=true&"
import script from "./TheSecurity.vue?vue&type=script&lang=js&"
export * from "./TheSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a922495",
  null
  
)

export default component.exports